import { useEffect, useState } from "react";
import Button1 from "../../../components/form/Button1";
import SuppliersInput from "../../../components/form/Flight/SuppliersInput";
import updateFlightSetting from "../../../controllers/settings/supplier/updateFlightSetting";
import { enqueueSnackbar } from "notistack";

export default function AutoPostTicketing({data,close,callback}) {
    const [loadings,setLoadings] = useState({submit: false});
    const [suppliers, setSuppliers] = useState(data?.flightProviders?.[data?.label] || []);

    useEffect(() => {
        setSuppliers(data?.flightProviders?.[data?.label] || []);
    },[data])
    
    console.log(data,suppliers)
    
    async function handleSubmit() {
        setLoadings({ ...loadings, submit: true })
        const res = await updateFlightSetting({ [data?.label]: suppliers });
        setTimeout(() => setLoadings({ ...loadings, submit: false }), 1000)
        if(res.return) {
            enqueueSnackbar('Successful', { variant: 'success' });
            callback && callback();
            close && close();
        } else enqueueSnackbar(res.msg, { variant: 'error' });
    }
    
  return (
    <div className="flex flex-col gap-4">
        <SuppliersInput data={suppliers} callback={(list) => setSuppliers(list)} />
        <div className="flex gap-4 items-center">
            <div>
                <Button1 variant='outlined' onClick={() => close && close()}>Cancel</Button1>
            </div>
            <Button1 loading={loadings.submit} onClick={() => handleSubmit()}>Submit</Button1>
        </div>

    </div>
  )
}
